export function phoneInputInit() {
  const inputsTel = document.querySelectorAll(".input_phone");

  inputsTel.forEach((input) => {
    const symbolPlus = input.parentElement.querySelector(".form_input_plus");

    // Сохраняем начальный паддинг
    const initialPaddingLeft = parseInt(window.getComputedStyle(input).paddingLeft, 10) || 0;

    input.addEventListener("input", replaceValues);
    input.addEventListener("paste", replaceValues);

    function replaceValues() {
      // Пересчитываем paddingIncrement на основе текущей ширины symbolPlus
      const paddingIncrement = symbolPlus.offsetWidth + 2;

      let value = this.value.replace(/\D/g, ""); // Убираем все не цифры
      this.value = value;

      if (
        value.startsWith("7") ||
        value.startsWith("+") ||
        value.startsWith("8") ||
        value.startsWith("9")
      ) {
        value = value.startsWith("9") ? value : value.substring(1); // Убираем первую цифру

        // Увеличиваем паддинг только если он равен начальному значению
        if (parseInt(input.style.paddingLeft, 10) !== initialPaddingLeft + paddingIncrement) {
          input.style.paddingLeft = `${initialPaddingLeft + paddingIncrement}px`;
          symbolPlus.style.left = `${initialPaddingLeft}px`;
        }

        symbolPlus.classList.add("visible");

        this.value = "7";
        if (value.length >= 1) {
          // this.value += value.substring(0, 10);
          this.value += value;
        }
      } else {
        input.style.paddingLeft = `${initialPaddingLeft}px`;
        symbolPlus.classList.remove("visible");
      }
    }
  });
}
